import { Form, Select } from "antd";
import { useEffect, useState } from "react";
import * as API from "@api";

export default function Language(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    API.Languages.getAll({ limit: 1000 }).then((res) => {
      if (res.error || !res) {
        return;
      }

      setData(res?.data?.rows || []);
    });
  }, []);

  return (
    <Form.Item
      {...props}
      name="language_id"
      className="w-fit m-0"
      rules={[{ required: true, message: "Please select a language" }]}
      initialValue={1}
    >
      <Select
        className="m-0"
        placeholder="Select one"
        filterOption={(input, option) =>
          option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? "")
            .toLowerCase()
            .localeCompare((optionB?.label ?? "").toLowerCase())
        }
        options={data.map((val) => {
          return {
            label: val.name,
            value: val.id,
          };
        })}
      />
    </Form.Item>
  );
}
